import React from "react";
import { Link } from "react-router-dom";
import { Award, Leaf, Flame, Heart } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { imageUrl } from "../lib/api";

export default function About() {
  const { content } = useContent();
  const ap = content?.about_page || {};
  return (
    <div data-testid="about-page">
      <section className="bg-navy hero-motif py-16 text-center px-4">
        <div className="overline text-gold">Our story</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-2">{ap.hero_title || "About Begum's Biryani Secrets"}</h1>
        <p className="text-gold italic font-serif text-xl mt-3">{ap.hero_subtitle || "Royal Flavours. Timeless Tradition."}</p>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid lg:grid-cols-2 gap-10 items-center">
        <div className="relative"><div className="absolute -inset-3 border border-gold/30 rounded-2xl" /><img src={imageUrl(ap.image1)} className="relative rounded-2xl w-full aspect-[4/3] object-cover" alt="Royal food" /></div>
        <div>
          <h2 className="font-serif text-3xl text-navy">{ap.heading || "A Legacy on Every Plate"}</h2>
          <p className="text-muted-foreground mt-4 leading-relaxed">{ap.para1}</p>
          <p className="text-muted-foreground mt-3 leading-relaxed">{ap.para2}</p>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-8">
        <div className="grid sm:grid-cols-4 gap-5">
          {[[Award, "Heritage Recipes", "Passed down generations"], [Leaf, "Fresh Ingredients", "Sourced daily"], [Flame, "Slow-Cooked", "Authentic dum method"], [Heart, "Made with Love", "Every single order"]].map(([Icon, t, d], i) => (
            <div key={i} className="bg-white rounded-xl border border-black/5 p-6 text-center card-hover">
              <Icon className="mx-auto text-gold mb-3" size={26} /><div className="font-serif text-lg text-navy">{t}</div><div className="text-xs text-muted-foreground mt-1">{d}</div>
            </div>
          ))}
        </div>
      </section>
      {(ap.gallery || []).filter(Boolean).length > 0 && (
        <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10" data-testid="about-gallery">
          <div className="text-center mb-6"><div className="overline text-gold">A glimpse</div><h2 className="font-serif text-3xl text-navy mt-1">From Our Kitchen</h2></div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {ap.gallery.filter(Boolean).map((img, i) => (
              <div key={i} className="rounded-xl overflow-hidden aspect-square card-hover" data-testid={`about-gallery-img-${i}`}>
                <img src={imageUrl(img)} alt={`Gallery ${i + 1}`} loading="lazy" className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </section>
      )}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10 text-center">
        <Link to={ap.cta_link || "/menu"} className="inline-flex bg-navy text-cream font-semibold px-8 py-3.5 rounded-full hover:bg-navy-soft transition-colors">{ap.cta_label || "Explore the Menu"}</Link>
      </section>
    </div>
  );
}
